import script from "./VerInventario.vue?vue&type=script&setup=true&lang=js"
export * from "./VerInventario.vue?vue&type=script&setup=true&lang=js"

import "./VerInventario.vue?vue&type=style&index=0&id=b0349e7a&lang=css"

const __exports__ = script;

export default __exports__